import React,{useEffect} from 'react'
import { Box,Container,Grid } from '@mui/material'
import EcxSurveyTopbar from './editorparts/EcxSurveyTopbar'
import EcxSurveyCanvas from './editorparts/EcxSurveyCanvas'
import EcxSurveyProperties from './editorparts/EcxSurveyProperties'
import EcxSurveyToolbar from './editorparts/EcxSurveyToolbar'
import { useSurveyStore } from './surveyutilities/surveyStore'

function EcxSurveyEditor({templateType = "template",loadjson=null,savejson,onSave,onPublish}) {

    const updateSurveyMetadata = useSurveyStore(state => state.updateSurveyMetadata);

    useEffect(()=>{
        updateSurveyMetadata({templateType:templateType});
        //console.log("template type:"+templateType)
    },[templateType,updateSurveyMetadata])
    return (
        <Container >
            <EcxSurveyTopbar onSave={onSave} onPublish = {onPublish} />
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    <Grid size={1}>
                        <EcxSurveyToolbar  />
                    </Grid>
                    <Grid size={7}>
                        <EcxSurveyCanvas />
                    </Grid>
                    <Grid size={4}>
                        <EcxSurveyProperties/>
                    </Grid>
                </Grid>
            </Box>

        </Container>
    )
}

export default EcxSurveyEditor